import { render, staticRenderFns } from "./LinkedContentDialogBody.vue?vue&type=template&id=6c4c8a1c&scoped=true"
import script from "./LinkedContentDialogBody.vue?vue&type=script&lang=js"
export * from "./LinkedContentDialogBody.vue?vue&type=script&lang=js"
import style0 from "./LinkedContentDialogBody.vue?vue&type=style&index=0&id=6c4c8a1c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c8a1c",
  null
  
)

export default component.exports